<!-- ============================================================== -->
<!-- Simple four boxes Row -->
<!-- ============================================================== -->
<div class="d-flex home-root-row" style="flex-wrap: wrap">
  <!-- column -->
  <div class="home-root-col">
    <mat-card appearance="outlined" >
      <mat-card-content class="home-main-card-content">

        <!-- Row -->
        <div class="d-flex" style="gap: 24px">
          <!-- column -->
          <div class="home-title-col">
            <span>
              <h3>{{ "home.title" | translate }}</h3></span
              >
            </div>
          </div>
          <br />
          <div class="d-flex flex-column" style="gap: 24px">
            <div>
              <p [innerHTML]="'home.intro1' | translate"></p>
              <p [innerHTML]="'home.intro2' | translate"></p>
            </div>
            @if (user && isMember) {
              <div
                class="form_to_fill_container padded-content d-flex flex-column"
                style="gap: 20px">
                <p
            [innerHTML]="
              'home.intro3'
                | translate : { years: years, currentYear: currentYear }
            "
                ></p>
                <p
            [innerHTML]="
              'home.intro4'
                | translate
                  : { currentDate: (currentDate | date : 'yyyy/MM/dd') }
            "
                ></p>
                <!-- Debut :
                de l'option pour le Inscription annuelle et
                cotisation à l’Ordre des dentistes du Québec -->
                <div
                  class="form_to_fill_content padded-content d-flex flex-column"
                  *odqMenuItem="'inscription'">
                  <p [innerHTML]="'home.annualRegistration' | translate"></p>
                  @if (!allInscriptionFormSubmitted) {
                    <div class="d-flex justify-content-center align-items-center"
                      >
                      <button
                        mat-flat-button
                        [routerLink]="['/', 'inscription']"
                        color="primary"
                        class="home-fill-form-link">
                        {{ "home.fillFormula" | translate }}
                      </button>
                    </div>
                  }
                  @if (isMember && allInscriptionFormSubmitted) {
                    <div class="d-flex justify-content-center align-items-center"
                      >
                      <!-- ONE CARD PER YEAR -->
                      @if (yearsInfos?.length > 0) {
                        @for (yearInfo of yearsInfos; track yearInfo) {
                          <mat-card
                            appearance="outlined"
                            class="home-year-info-card">
                            <mat-card-content>
                              <h3>
                                {{
                                "inscription.yearSelection.formForYear" | translate
                                }}
                                {{ yearInfo.year }}
                              </h3>
                              <!-- NOT SUBMITTED -->
                              @if (
                                yearInfo.state !== 'SUBMITTED' &&
                                yearInfo.state !== 'ERROR'
                                ) {
                                <div
                                  >
                                  @if (
                                    !!(memberRegistrationSettings$ | async)
                                    ?.disableAccessToForm) {
                                    <span
                                      >
                                      {{
                                      "inscription.yearSelection.noFormAccess" | translate
                                      }}
                                    </span>
                                  } @else {
                                    @if (isFormOpened(yearInfo)) {
                                      <button
                                        mat-raised-button
                                        color="primary"
                                        (click)="selectYear(yearInfo.year)"
                                        >
                                        {{
                                        "inscription.yearSelection.fillForm" | translate
                                        }}
                                      </button>
                                    }
                                    <!-- NOT OPENED -->
                                    @if (!isFormOpened(yearInfo)) {
                                      <span>
                                        {{
                                        "inscription.yearSelection.notOpenedYet"
                                        | translate
                                        }}
                                      </span>
                                    }
                                  }
                                </div>
                              }
                              <!-- ALREADY SUBMITTED -->
                              @if (yearInfo.state === 'SUBMITTED') {
                                <div>
                                  <span>{{
                                    "inscription.yearSelection.formSubmitted" | translate
                                  }}</span>
                                  @if (!!yearInfo?.pdfDocumentId) {
                                    <div
                                      class="mt-2 d-flex justify-content-start align-items-center"
                                      >
                                      <button
                                        mat-raised-button
                                        class="mt-2"
                                        color="primary"
                                        (click)="pdf(yearInfo)"
                                        >
                                        <mat-icon>file_download</mat-icon>
                                        {{
                                        "inscription.yearSelection.downloadForm"
                                        | translate
                                        }}
                                      </button>
                                      <img
                                        class="img-responsive ml-2"
                                        src="/assets/images/pdf-icon.png"
                                        width="40"
                                        />
                                      </div>
                                    }
                                    @if (!yearInfo?.pdfDocumentId) {
                                      <span class="mt-2">
                                        {{
                                        "inscription.yearSelection.pdfNotAvailable"
                                        | translate
                                        }}
                                      </span>
                                    }
                                  </div>
                                }
                              </mat-card-content>
                            </mat-card>
                          }
                        } @else {
                          @if (loading$ | async) {
                            <div
                              class="loading-spinner"
                              >
                              <mat-spinner diameter="50"></mat-spinner>
                            </div>
                          } @else {
                            <div
                              class="text-center mt-5 information_notice d-flex flex-column" style="flex: 1 1 0%">
                              <p
                                [innerHTML]="
                                  'emptyStates.inscription.tagline' | translate
                                "
                              ></p>
                            </div>
                          }
                        }
                        <!-- END ONE CARD PER YEAR -->
                      </div>
                    }
                  </div>
                  <odq-home-farp-odq></odq-home-farp-odq>
                  <odq-home-legal-entity></odq-home-legal-entity>
                </div>
              }

              <div class="d-flex flex-column" style="gap: 24px">
                @if (!isAuthorized) {
                  <div class="d-flex flex-wrap home-dash-actions-row"
                    >
                    <div class="home-dash-col">
                      <button
                        mat-flat-button
                        color="primary"
                        class="portal-button"
                        (click)="login()">
                        {{ 'profile.sign_in' | translate }}
                      </button>
                    </div>
                    <div class="home-dash-col">
                      <button
                        mat-flat-button
                        color="primary"
                        class="portal-button"
                        (click)="resetPassword()">
                        {{ 'profile.resetPassword' | translate }}
                      </button>
                    </div>
                  </div>
                }

                @if (!user) {
                  <div class="d-flex flex-wrap home-dash-actions-row"
                    >
                    <div *odqMenuItem="'formation'" class="home-dash-col">
                      <button
                        class="portal-button home-btn-large-text"
                        *odqMenuItem="'inscription'"
                        mat-flat-button
                        [routerLink]="['/', 'inscription']"
                        color="primary">
                        {{ "home.inscription" | translate }}<br/>
                        {{ "home.inscriptionPeriod" | translate }}
                    </button>
                    </div>
                    <div *odqMenuItem="'formation'" class="home-dash-col">
                      <button
                        class="portal-button home-btn-large-text"
                        mat-flat-button
                        [routerLink]="['/', 'farp-subscription']"
                        target="_blank"
                        color="primary">
                        {{ "home.subscription" | translate }}<br/>                        
                      </button>
                    </div>
                  </div>
                }

                @if (!user) {
                  <div class="d-flex flex-wrap home-dash-actions-row"
                    >
                    <div *odqMenuItem="'formation'" class="home-dash-col">
                      <button
                        class="portal-button home-btn-large-text"
                        *odqMenuItem="'company'"
                        mat-flat-button
                        [routerLink]="['/', 'company']"
                        color="primary">
                        {{ "legalEntity.buttonTitle" | translate }}<br/>
                        {{ "legalEntity.buttonTitlePeriod" | translate }}
                      </button>
                    </div>
                    <div *odqMenuItem="'addresses'" class="home-dash-col">
                      <button
                        mat-flat-button
                        [routerLink]="['/', 'addresses']"
                        color="primary"
                        class="portal-button">
                        {{ "addresses.title" | translate }}
                      </button>
                    </div>
                  </div>
                }

                <div class="d-flex flex-wrap home-dash-actions-row">
                  <div *odqMenuItem="'formation'" class="home-dash-col">
                    <button
                      mat-flat-button
                      [routerLink]="['/', 'continuing-education']"
                      color="primary"
                      class="portal-button">
                      {{ "formation.trainingRecord" | translate }}
                    </button>
                  </div>

                  @if (!user || isMember) {
                    <div class="home-dash-col">
                      <a
                        mat-flat-button
                        href="https://dentoform.ca/Web/MyDashboard"
                        target="_blank"
                        color="primary"
                        class="portal-button">
                        {{ "home.dentoform" | translate }}
                      </a>
                    </div>
                  }
                </div>

                <div class="d-flex flex-wrap home-dash-actions-row">
                  <div
                    *odqMenuItem="'member-card'"
                    class="home-dash-col">
                    <button
                      mat-flat-button
                      [routerLink]="['/', 'member-card']"
                      color="primary"
                      class="portal-button">
                      {{ "memberCard.title" | translate }}
                    </button>
                  </div>
                  @if (user) {
                    <div class="home-dash-col">
                      <button
                        mat-flat-button
                        *odqMenuItem="'addresses'"
                        [routerLink]="['/', 'addresses']"
                        color="primary"
                        class="portal-button">
                        {{ "addresses.title" | translate }}
                      </button>
                    </div>
                  }
                  @if (!isProduction && !isAssistant) {
                    <div class="home-dash-col">
                      <button
                        mat-flat-button
                        color="primary"
                        class="portal-button"
                        (click)="createUser()">
                        {{ "home.createDentalAssistantAccount" | translate }}
                      </button>
                    </div>
                  }
                </div>
                @if (!user) {
                  <div class="d-flex flex-wrap home-dash-actions-row"
                    >
                    <div class="home-dash-col">
                      <button mat-flat-button [routerLink]="['/', 'payment']" color="primary" class="portal-button">
                        {{ 'home.payment' | translate }}
                      </button>
                    </div>
                  </div>
                }
                <div class="d-flex flex-wrap home-dash-actions-row">
                  @if (user) {
                    <div class="home-dash-col">
                      <button
                        mat-flat-button
                        color="primary"
                        class="portal-button"
                        (click)="resetPassword()">
                        {{ 'profile.resetPassword' | translate }}
                      </button>
                    </div>
                  }

                </div>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
      <!-- column -->
    </div>
